export const GIFT_CARD_DEFAULT_VALUE = 2500;
